export type NestButtonVariant =
  | 'primary'
  | 'secondary'
  | 'outline'
  | 'link'

export enum NestButtonVariants {
  primary = 'primary',
  secondary = 'secondary',
  outline = 'outline',
  link = 'link'
}

export type NestButtonSize =
  | "small"
  | "medium"
  | "large"
